<template>
    <div>
        <div v-for="notification in displayedNotifications" class="alert site-notification alert-dismissible" :class="`alert-${notification.level}`">
            <button type="button" class="close" aria-hidden="true" @click="hideNotification(notification)">&times;</button>
            <strong>{{ notification.title }}</strong>
            <span class="nl2br">{{ notification.body }}</span>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

function notificationHash(notification) {
    return `${notification.id}-${notification.updated_at}`;
}

export default {
    data() {
        return {
            hiddenNotifications: [],
        };
    },
    computed: {
        ...mapGetters({ siteNotifications: 'data/activeSiteNotifications' }),
        displayedNotifications() {
            return this.siteNotifications.filter(n => this.hiddenNotifications.indexOf(notificationHash(n)) < 0);
        },
    },
    methods: {
        hideNotification(notification) {
            this.hiddenNotifications.push(notificationHash(notification));
        },
    },
}
</script>
